import { configureApiEntity } from '../adapter';
import { schema } from 'normalizr';
import { vatTypeSchema } from './vatType';

const ledgerSchema = new schema.Entity('ledgers', {
    vatType: vatTypeSchema,
});

export const ledgers = configureApiEntity('LEDGERS', 'ledgers', ledgerSchema);
